import Toast from './toast.jsx'
import { VueExtension } from '../../utils/extensions/vue.js'

export default VueExtension.InvokeComponent(unmount=>({
    data(){
        return {
            options:{
                show:false,
                overlay: false,
                zIndex: 1030,
                duration: 1600,
                overlayStyle: {},
                closeOnClickOveraly: true,
                position: 'center',
                message: '',
                theme: 'dark',
                icon: '',
                loading: false
            }
        }
    },
    methods:{
        open(options){
            this.options = {...this.options, ...options, show:true}
        },
        onClose(){
            unmount()
        }
    },
    render(){
        return (
            <Toast {...{props:this.options}}  vOn:close={this.onClose}/>
        )
    }
}))